import { useListView } from '../../core/ListViewProvider'
import { CargoClienteListGrouping } from './CargoClienteListGrouping'
import { CargoClienteListSearchComponent } from './CargoClienteListSearchComponent'
import { CargoClienteListToolbar } from './CargoClienteListToolbar'

export const CargoClienteListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <CargoClienteListSearchComponent
        actions={selected.length > 0 ? <CargoClienteListGrouping /> : <CargoClienteListToolbar />}
      />
    </div>
  )
}
